import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d3b0814"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "program-inner" }
const _hoisted_4 = { class: "program-title" }
const _hoisted_5 = {
  key: 0,
  class: "program-place"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "program-heading" }, "参加方法", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "program-heading" }, "How to Participate", -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 5,
  class: "program-attention"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 6,
  class: "program-attention"
}
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "program-box",
      key: item.id,
      id: item.id
    }, [
      _createElementVNode("img", {
        class: "program-image",
        src: item.image,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platform, (label) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["program-label", {
            '-vrc': label === 'VRChat',
            '-neos': label === 'Resonite',
            '-stream': label === 'Streaming',
          }]),
              key: label
            }, _toDisplayString(label), 3))
          }), 128)),
          (_ctx.locale === 'ja' || !item.title_en)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item.title), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(item.title_en), 1)
              ], 64))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["program-time", {
          '-day_1': item.datelabel === 'day_1',
          '-day_2': item.datelabel === 'day_2',
          '-day_3': item.datelabel === 'day_3',
          '-day_4': item.datelabel === 'day_4',
        }])
        }, [
          (_ctx.locale === 'ja' || !item.date_en)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item.date), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(item.date_en), 1)
              ], 64))
        ], 2),
        (item.place)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.locale === 'ja' || !item.place_en)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 場所：" + _toDisplayString(item.place), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Location: " + _toDisplayString(item.place_en), 1)
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.locale === 'ja' || !item.description_en)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "program-description",
              innerHTML: item.description
            }, null, 8, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "program-description",
              innerHTML: item.description_en
            }, null, 8, _hoisted_7)),
        (_ctx.locale === 'ja' && item.access)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _hoisted_8,
              _createElementVNode("div", {
                class: "program-access",
                innerHTML: item.access
              }, null, 8, _hoisted_9)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.locale === 'en' && item.access_en)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _hoisted_10,
              _createElementVNode("div", {
                class: "program-access",
                innerHTML: item.access_en
              }, null, 8, _hoisted_11)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.locale === 'ja' || !item.attention_en)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attention, (note, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "item",
                  key: 'key-' + index,
                  innerHTML: note
                }, null, 8, _hoisted_13))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attention_en, (note, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "item",
                  key: 'key-' + index,
                  innerHTML: note
                }, null, 8, _hoisted_15))
              }), 128))
            ]))
      ])
    ], 8, _hoisted_1))
  }), 128))
}